import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

export type QuoteRequestLineCustomInputsDto = ClientInferResponseBody<
  typeof contract.quoteRequestLines.findCustomInputs
>;

export const fetchQuoteRequestLineCustomInputs = async (
  id: string | undefined,
): Promise<QuoteRequestLineCustomInputsDto | null> => {
  if (!id) {
    return null;
  }

  const response = await api.quoteRequestLines.findCustomInputs.query({
    params: { id },
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
